__turbopack_context__.v({
  "skipLink": "_8_GlZG_skipLink",
});
